import { publicRuntimeConfig } from "#next/utils/publicRuntimeConfig";
const _APP_ENV = publicRuntimeConfig.APP_ENV;
const _APP_VERSION = publicRuntimeConfig.APP_VERSION;

/*
The way these environment variables work is super confusing (which I think
is fixed in the next version of NextJS). Hopefully I get this right:
In order to have an env var available to the front-end via `publicRuntimeConfig`
in a production build of the app we need the 
var to be set at build time (so much for "runtimeConfig"...). 
We also need to set it at runtime for development, so it goes into `env.js` as a 
required variable. Which means that when running a production build it also needs to
be in the environment (even though the _actual value_ will come from the build-time value)
otherwise `env.js` will fail to validate the environment variables and crash the app.
We could get rid of `env.js` as it's a tRPC convenience, not a NextJS thing, but it's actually
a good thing to have the required environment variables in one place and checked
with a zod schema.
So the upshot is that these variables need to be set at build time, and also set at runtime, even
if the runtime setting is only relevant to development mode.
Hopefully we can get rid of this oddness. If so please make sure that APP_ENV and APP_VERSION
are only set in one place. Currently we set both of them at container build time (in the Github Action)
and again at runtime via the Pulumi k8s code.
*/

if (!_APP_ENV) {
  throw new Error("Missing environment variable APP_ENV");
}

if (
  !(
    _APP_ENV === "development" ||
    _APP_ENV === "production" ||
    _APP_ENV === "pre-release" ||
    _APP_ENV === "local" ||
    _APP_ENV === "test"
  )
) {
  throw new Error(`Invalid APP_ENV: ${_APP_ENV}`);
}

export const APP_ENV = _APP_ENV;

if (!_APP_VERSION) {
  throw new Error("Missing environment variable APP_VERSION");
}

export const APP_VERSION = _APP_VERSION;

console.log(`APP_ENV="${APP_ENV}" APP_VERSION="${APP_VERSION}"`);
